const getters = {
    language:state => state.webSite.language,
    device:state => state.webSite.device,
}
export default getters